import { SiteConfig } from "../hooks/useSiteConfig"

// Global configuration store for pixel tracking
let globalSiteConfig: SiteConfig | null = null

/**
 * Set the global site configuration for pixel tracking
 * This should be called once during app initialization with the site config
 */
export const setSiteConfig = (config: SiteConfig): void => {
  globalSiteConfig = config
}

/**
 * Get the current site configuration for pixel tracking
 * Returns null if configuration hasn't been set yet
 */
export const getSiteConfig = (): SiteConfig | null => {
  return globalSiteConfig
}

/**
 * Check if a specific feature is enabled in the site config
 * Returns false if config is not available or feature is disabled
 */
export const isFeatureEnabled = (feature: keyof SiteConfig): boolean => {
  if (!globalSiteConfig) {
    return false
  }
  return Boolean(globalSiteConfig[feature])
}
